// extracted by mini-css-extract-plugin
export default {"header":"DiningOptionSelector-module__header___1l-3O","flex":"DiningOptionSelector-module__flex___1dby7","errorMessage":"DiningOptionSelector-module__errorMessage___yFP7a"};